<template>
	<a-layout style="padding: 24px 0">
		<a-layout-content><router-view /></a-layout-content>
	</a-layout>
</template>

<script>
export default {
	data() {
		return {};
	}
};
</script>

<style></style>
